import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DOMPurify from "dompurify";

const BlogThumbnail = ({ requiredData, IsBlogData }) => {

    const [data, setData] = useState(null);

    useEffect(() => {
        
        async function fetchData() {
            try {
                const response = await axios.get('https://admin.balcopipes.in/blog/blog-post');
                setData(response.data);
                if(response.data && IsBlogData) {
                    IsBlogData(true);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        fetchData();
    }, []);


    const [openModalIndex, setOpenModalIndex] = useState(null);

    const toggleModal = (index) => {
        setOpenModalIndex(openModalIndex === index ? null : index);
        if (openModalIndex === null) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    };

    const DealerModal = ({ data }) => {
        return (
            <div className="modal" tabIndex="9999" role="dialog" style={{ display: 'block', overflow: "hidden" }}>
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content" style={{ display: 'block', overflow: "auto", height: "500px" }}>
                        <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: "5px 15px" }}>
                            <h5 className="dealer-heading heading mb-0">Blog Details</h5>
                            <button type="button" className="btn btn-none close" onClick={() => toggleModal(null)}>
                                <i className="bi bi-x-lg" style={{ color: 'red', fontSize: "20px", fontWeight: "bold" }} ></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 d-flex">
                                    <div className="p-2 flex-grow-1">
                                        <img src={ data.image && "https://admin.balcopipes.in/" + data.image} width={'100%'} height={350} alt="blog_photo" />
                                    </div>
                                </div>
                                <div className="col-md-12 d-flex">
                                    <div className="p-2 flex-grow-1">
                                        <div className="d-flex px-3" style={{ justifyContent: "space-between", alignItems: "center" }}>
                                            <p className="blog-text text">Blog</p>
                                            <p className="blog-text text">{data.date && data.date}</p>
                                        </div>
                                        <div className="my-2 px-3" style={{ height: "100px" }}>
                                            <h5 className="blog-subheading subheading">
                                                <span className="fw-bold">Title: </span>{data.blog_title && data.blog_title}
                                            </h5>
                                            <p className="blog-subheading subheading mt-3 mb-1">Description:</p>
                                            <div className="d-block">
                                                <div className="py-4" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`${data.description}
                                                <div style="display: flex; justify-content: space-between; align-items: center; padding-top: 15px;">
                                                    <p className="blog-text text" >Created by ${data.editor.email && data.editor.email}</p>
                                                    ${data.editor.profile_image ? `<div class="profile-image-container" style="width: 50px; height: 50px; border-radius: 50%;">
                                                        <img src=${"https://admin.balcopipes.in/" + data.editor.profile_image && data.editor.profile_image } alt="profile_image" width="100%" />
                                                    </div>` : ''}
                                                </div>
                                                `) }} />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    };

    return (
        <div className="row">
            {data && data.data.slice(0, requiredData).map((item, index) => (
                <div className="col-lg-4 col-md-6 d-flex my-3" key={index} style={{ flexFlow: "column", justifyContent:"space-evenly" }}>
                    <div className="flex-grow-1 blog-box pb-2" style={{borderBottom:"none", boxShadow: 'none'}}>
                    <div >
                        <div>
                            <img src={item.image && "https://admin.balcopipes.in/" + item.image} width={'100%'} style={{ height: '285px' }} alt={'image-' + index} />
                        </div>
                        <div className="d-flex p-3" style={{ justifyContent: "space-between", alignItems: "center" }}>
                            <p className="blog-text text">Blog</p>
                            <p className="blog-text text">{item.date && item.date}</p>
                        </div>
                        <div className="my-2 px-3" >
                            <h5 className="blog-subheading subheading">
                                {item.blog_title && item.blog_title}
                            </h5>
                        </div>
                    </div>
                    </div>
                    <div className='blog-box' style={{borderTop:"none"}}>
                            <div className="d-flex p-3" style={{ justifyContent: "space-between", alignItems: "center" }}>
                                <p className="blog-text text" onClick={() => toggleModal(index)} style={{ cursor: "pointer" }}>read me </p>
                                {openModalIndex === index && <DealerModal data={item} />}
                                {item.editor.profile_image &&
                                <div style={{ width: '50px', height: '50px', borderRadius: "50%", display: item.editor.profile_image ? 'block' : 'none' }}>
                                    <img src={`https://admin.balcopipes.in${item.editor.profile_image}` } alt={"profile_image"} width={'100%'} />
                                </div>
                                 }
                            </div>
                        </div>
                </div>
            ))}
        </div>
    );
};

export default BlogThumbnail;

 // blog_title : "Revolutionizing Industries One Flow at a Time"
    // category: {category_name: "Industrial Solutions"}
    // date: "2024-04-12"
    // description: "<p>In the grand tapestry of industrial progress, it&#39;s often the unsung heroes that make the most significant impact. Among these silent champions stand pipes - the conduits of modern civilization. From carrying water to transporting fluids and gases vital for various processes, pipes are the lifelines of numerous industries.</p>\r\n\r\n<p>At [Company Name], we understand the pivotal role pipes play in driving progress. With decades of expertise and a commitment to innovation, we&#39;re at the forefront of revolutionizing industries through our comprehensive range of piping solutions.</p>\r\n\r\n<p><strong>Engineering Excellence:</strong></p>\r\n\r\n<p>Our pipes aren&#39;t just conduits; they&#39;re engineered marvels crafted to withstand the harshest conditions and deliver unparalleled performance. Whether it&#39;s ensuring the uninterrupted flow of water in municipal systems or safeguarding critical processes in manufacturing plants, our pipes are designed to exceed expectations.</p>\r\n\r\n<p><strong>Tailored Solutions:</strong></p>\r\n\r\n<p>We recognize that every industry has its unique challenges and requirements. That&#39;s why we offer customized piping solutions tailored to meet the specific needs of each sector. From high-pressure applications in the oil and gas industry to corrosion-resistant materials for chemical processing, we have the expertise to deliver precisely what our clients need.</p>\r\n\r\n<p><strong>Sustainability Focus:</strong></p>\r\n\r\n<p>In an era where sustainability is paramount, our commitment to eco-friendly practices sets us apart. We prioritize the use of recyclable materials in our manufacturing processes and continually innovate to minimize our environmental footprint. With our sustainable piping solutions, clients can not only enhance efficiency but also contribute to a greener future.</p>\r\n\r\n<p><strong>Customer-Centric Approach:</strong></p>\r\n\r\n<p>At the heart of our operations lies a dedication to customer satisfaction. We don&#39;t just sell pipes; we forge lasting partnerships with our clients, offering comprehensive support from project inception to completion. Our team of experts provides technical assistance, conducts thorough feasibility studies, and ensures seamless implementation, ensuring that every client&#39;s needs are met with precision.</p>\r\n\r\n<p><strong>Embracing Innovation:</strong></p>\r\n\r\n<p>Innovation is the cornerstone of our ethos. We invest heavily in research and development to stay ahead of the curve, constantly seeking new ways to improve the performance, durability, and efficiency of our pipes. Whether it&#39;s integrating IoT technology for predictive maintenance or pioneering new materials for enhanced durability, we&#39;re committed to pushing the boundaries of what pipes can achieve.</p>\r\n\r\n<p><strong>Join the Pipe Revolution:</strong></p>\r\n\r\n<p>As industries evolve and challenges grow more complex, the need for reliable, efficient piping solutions has never been greater. At [Company Name], we invite you to join us in embracing the pipe revolution. Together, let&#39;s build a future where the flow of progress knows no bounds.</p>"
    // editor: {id: 1, email: "admin@gmail.com", profile_image: "/media/profile_image/default.png"}
    // id: 1
    // image: "/media/blog_image/dealer.df5662462f84c5491d8e.png"
    // image_description: "description"
    // status: "Pending"
    // sub_category: {subcategory_name: "Infrastructure Development"}